define((require) => {
    "use strict";

    const AbstractWidgetPropertiesView    = require("ui/experience/widgets/AbstractWidgetPropertiesView");
    const SizeAndPositionPropertiesView   = require("ui/experience/widgets/SizeAndPositionPropertiesView");
    const template                        = require("ui/experience/widgets/compositeWidget/CompositeWidgetPropertiesView.tpl");

    /**
     * The properties view for a composite widget.
     *
     * @class CompositeWidgetPropertiesView
     * @constructor
     *
     * @cfg {CompositeWidgetModel} model The model for the composite widget being edited.
     */
    return AbstractWidgetPropertiesView.extend("CompositeWidgetPropertiesView", {
        template,

        regions: {
            sizeAndPositionProperties: ".size-and-position-properties"
        },

        onRender() {
            this.sizeAndPositionProperties.show(new SizeAndPositionPropertiesView({
                model: this.model,
                editorViewModel: this.viewScope.viewModel,
                shouldExpandOnRender: true,
                hideSizeControls: true,
                hideRotation: true,
                widgetView: this.options.widgetView
            }));
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/experience/widgets/compositeWidget/CompositeWidgetPropertiesView.js